<template lang="pug">
nav
	.font-weight-bold.subtitle-1 {{ $t('nav.live')}}
	ul.list-unstyled
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather'})", :title="$t('nav.forecast.title')") {{ $t('nav.forecast')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-snowheight'})", :title="$t('nav.snowheight.title')") {{ $t('nav.snowheight')}}
		template(v-if="$nuxt.$route.name.startsWith('weather-snowheight')")
			li.ml-4.nav-list-item.tabbed(v-for="country in snowheight_countries")
				img.flag(:src="`https://static.wintersport.nl/images/flags/svg/${country.countryCode}.svg`", :alt="country.name" width="16")
				nuxt-link.never-visited(:to="localePath({name: 'weather-snowheight-country', params: {country: country.slug}})" :title="$t('nav.snowheight.{country}.title', {country: country.name})") {{ $t('nav.snowheight.{country}', {country: country.name})}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-webcams'})", :title="$t('nav.webcams.title')") {{ $t('nav.webcams')}}

	.font-weight-bold.subtitle-1 {{ $t('nav.alps')}}
	ul.list-unstyled
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('snowforecast', $i18n.locale)}})", :title="$t('nav.alps.snowforecast.title')") {{ $t('nav.alps.snowforecast')}}
				small.grey--text &nbsp;({{ $t('nav.cumulative')}})
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('snowfall', $i18n.locale)}})", :title="$t('nav.alps.snowfall.title')") {{ $t('nav.alps.snowfall')}}
				small.grey--text &nbsp;(per 24 uur)
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('snowradar', $i18n.locale)}})", :title="$t('nav.alps.snowradar.title')") {{ $t('nav.alps.snowradar')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('sun', $i18n.locale)}})", :title="$t('nav.alps.sun.title')") {{ $t('nav.alps.sun')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('clouds', $i18n.locale)}})", :title="$t('nav.alps.clouds.title')") {{ $t('nav.alps.clouds')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('temperature', $i18n.locale)}})", :title="$t('nav.alps.temperature.title')") {{ $t('nav.alps.temperature')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-type', params: {type: $localeSlug('wind', $i18n.locale)}})", :title="$t('nav.alps.wind.title')") {{ $t('nav.alps.wind')}}

	.font-weight-bold.subtitle-1 {{ $t('nav.europe')}}
	ul.list-unstyled
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('snowforecast', $i18n.locale)}})", :title="$t('nav.europe.snowforecast.title')") {{ $t('nav.europe.snowforecast')}}
				small.grey--text &nbsp;({{ $t('nav.cumulative')}})
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('snowfall', $i18n.locale)}})", :title="$t('nav.europe.snowfall.title')") {{ $t('nav.europe.snowfall')}}
				small.grey--text &nbsp;(per 24 uur)
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('snowradar', $i18n.locale)}})", :title="$t('nav.europe.snowradar.title')") {{ $t('nav.europe.snowradar')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('sun', $i18n.locale)}})" :title="$t('nav.europe.sun.title')") {{ $t('nav.europe.sun')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('clouds', $i18n.locale)}})", :title="$t('nav.europe.clouds.title')") {{ $t('nav.europe.clouds')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('temperature', $i18n.locale)}})", :title="$t('nav.europe.temperature.title')") {{ $t('nav.europe.temperature')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('temp850', $i18n.locale)}})", :title="$t('nav.europe.temp850.title')") {{ $t('nav.europe.temp850')}}
				small.grey--text &nbsp;{{ $t('nav.europe.temp850.sub')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('wind', $i18n.locale)}})", :title="$t('nav.europe.wind.title')") {{ $t('nav.europe.wind')}}
		li.nav-list-item
			nuxt-link.never-visited(:to="localePath({name: 'weather-europe-type', params: {type: $localeSlug('jetstream', $i18n.locale)}})", :title="$t('nav.europe.jetstream.title')") {{ $t('nav.europe.jetstream')}}

	.font-weight-bold.subtitle-1 {{ $t('nav.webcams')}}
	ul.list-unstyled.mb-6(v-if="$nuxt.$route.name.startsWith('weather-webcams')")
		li.nav-list-item(v-for="(country, index) in webcam_countries" v-if="index < 5 || showAllWebcamCountries")
			img.flag(:src="`https://static.wintersport.nl/images/flags/svg/${country.countryCode}.svg`", :alt="country.name" width="16")
			nuxt-link.never-visited(:to="localePath({name: 'weather-webcams-country', params: {country: country.slug}})" :title="$t('nav.webcams.{country}.title', {country: country.name})") {{ $t('nav.webcams.{country}', {country: country.name})}}
		li.nav-list-item(v-if="!showAllWebcamCountries")
			a.never-visited.ws.ws-caret-down(href="#" @click.prevent="setShowAllWebcamCountries(true)") {{$t('nav.webcams.show_all_countries')}}
	figure.mb-6(v-else)
		nuxt-link(:to="localePath({name: 'weather-webcams'})" :title="$t('nav.webcams.title')")
			v-img(src="https://images-webcams.windy.com/40/1182426740/current/preview/1182426740.jpg" max-width="auto")

	ad(location="navigation")

</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	data() {
		return {};
	},
	computed: {
		...mapState(['showAllWebcamCountries']),
		snowheight_countries() {
			return this.$store.state.countries.slice(0, 5);
		},
		webcam_countries() {
			return this.$store.state.countries;
		}
	},
	methods: {
		...mapMutations(['setShowAllWebcamCountries'])
	}
};
</script>
